export const shouldShowPremiumRequired = (
  isAppRequiredPremium: boolean,
  isPremiumSite: boolean,
): boolean => {
  return isAppRequiredPremium && !isPremiumSite;
};
